// Ẩn các giá trị option không tồn tại cùng lựa chọn hiện tại, ví dụ sản phẩm có
// Style Men/Women với bộ size khác nhau: chọn Women thì chỉ hiện size của Women.
//
// Option được lọc theo thứ tự: option thường (Style, Color...) trước, option Size
// sau cùng. Mỗi option chỉ bị lọc bởi các option đứng trước nó, nên Style luôn
// hiện đủ giá trị để khách đổi được, còn Size chỉ hiện các size hợp lệ.
(function (root) {
  var SIZE_NAME = /size|kích|cỡ/i;

  function filterOrder(optionNames) {
    var indices = optionNames.map(function (_, i) { return i; });
    var regular = indices.filter(function (i) { return !SIZE_NAME.test(optionNames[i] || ''); });
    var sizes = indices.filter(function (i) { return SIZE_NAME.test(optionNames[i] || ''); });
    return regular.concat(sizes);
  }

  /**
   * Trả về giá trị được phép của từng option và lựa chọn đã sửa: nếu giá trị
   * đang chọn không còn hợp lệ thì đổi sang giá trị hợp lệ đầu tiên, ưu tiên
   * variant còn hàng.
   */
  function resolve(optionNames, variants, selected) {
    var nextSelected = selected.slice();
    var allowed = optionNames.map(function () { return []; });
    var fixed = [];

    filterOrder(optionNames).forEach(function (index) {
      var matching = variants.filter(function (v) {
        return fixed.every(function (f) { return v.options[f] === nextSelected[f]; });
      });

      matching.forEach(function (v) {
        var value = v.options[index];
        if (value != null && allowed[index].indexOf(value) === -1) allowed[index].push(value);
      });

      if (allowed[index].length && allowed[index].indexOf(nextSelected[index]) === -1) {
        var available = matching.find(function (v) { return v.available; });
        nextSelected[index] = available ? available.options[index] : allowed[index][0];
      }
      fixed.push(index);
    });

    return { allowed: allowed, selected: nextSelected };
  }

  /**
   * Áp kết quả lên DOM. `wrappers` là danh sách khối option theo thứ tự option,
   * mỗi khối có `data-option-name` và các `.variant-pill[data-value]`, pill
   * đang chọn mang class `active-pill`. Khi lựa chọn phải đổi, hàm click vào
   * pill mới để handler của từng nơi tự cập nhật variant (handler đó gọi lại
   * hàm này cho các option còn lại).
   */
  function apply(wrappers, variants) {
    wrappers = Array.prototype.slice.call(wrappers);
    if (!wrappers.length || !variants || !variants.length) return;

    var names = wrappers.map(function (w) { return w.getAttribute('data-option-name') || ''; });
    var selected = wrappers.map(function (w) {
      var active = w.querySelector('.variant-pill.active-pill');
      return active ? active.getAttribute('data-value') : null;
    });
    var result = resolve(names, variants, selected);

    for (var i = 0; i < wrappers.length; i++) {
      wrappers[i].querySelectorAll('.variant-pill').forEach(function (pill) {
        var visible = result.allowed[i].indexOf(pill.getAttribute('data-value')) !== -1;
        pill.style.display = visible ? '' : 'none';
      });
    }

    for (var j = 0; j < wrappers.length; j++) {
      if (result.selected[j] === selected[j]) continue;
      var target = Array.prototype.find.call(wrappers[j].querySelectorAll('.variant-pill'), function (pill) {
        return pill.getAttribute('data-value') === result.selected[j];
      });
      if (target) {
        target.click();
        return;
      }
    }
  }

  var api = { resolve: resolve, apply: apply };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.EzsportVariantFilter = api;
})(typeof window !== 'undefined' ? window : this);
